"use strict";

var _id = 0;

module.exports = function generateId() {
  return "simplepostmd-editor-" + ++_id;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simplemde-editor/lib/services/idGenerator.js
// module id = 1155
// module chunks = 0